<template>
  <div v-if="$auth.check()" class="be-left-sidebar">
    <div class="left-sidebar-wrapper"><a href="/#/client" class="left-sidebar-toggle">Главная</a>
      <div class="left-sidebar-spacer">
        <div class="left-sidebar-scroll">
          <div class="left-sidebar-content">
            <ul class="sidebar-elements">
              <li class="divider">Меню</li>
              <template v-if="$user.get().role !== 'guest'">
                <router-link v-if="!singleOperator" :to="{name: 'dashboard'}" tag="li" active-class="active"><a><i
                  class="icon mdi mdi-accounts-list"></i>Внесение данных</a>
                </router-link>
                <router-link v-if="singleOperator"
                             :to="{name: 'operator-visits', params: {operatorId: this.currentOperator.id}}" tag="li"
                             active-class="active"><a><i
                  class="icon mdi mdi-accounts-list"></i>Внесение данных</a></router-link>
                <router-link :to="{name: 'operators'}" tag="li" active-class="active"><a><i
                  class="icon mdi mdi-pin"></i>Операторы
                  сбора</a>
                </router-link>
                <router-link :to="{name: 'support'}" tag="li" active-class="active"><a><i
                  class="icon mdi mdi-help"></i>Служба поддержки</a>
                </router-link>
                <template v-if="is_superuser">
                  <li class="divider">Администрирование</li>
                  <router-link :to="{name: 'stats'}" tag="li" active-class="active"><a><i
                    class="icon mdi mdi-chart"></i>Статистика</a>
                  </router-link>
                  <router-link :to="{name: 'liveStats'}" tag="li" active-class="active"><a><i
                    class="icon mdi mdi-chart"></i>Статистика данных</a>
                  </router-link>
                  <router-link :to="{name: 'violations'}" tag="li" active-class="active"><a><i
                    class="icon mdi mdi-assignment-alert"></i>Нарушения</a>
                  </router-link>
                  <router-link :to="{name: 'revisions'}" tag="li" active-class="active"><a><i
                    class="icon mdi mdi-collection-text"></i>Акты сверки</a>
                  </router-link>
                </template>
                <li class="divider">Инструкции</li>
                <router-link :to="{name: 'importfile-manual'}" tag="li" active-class="active"><a><i
                  class="icon mdi mdi-pin-help"></i>Импорт данных из xml</a>
                </router-link>
              </template>
              <router-link v-if="$user.get().role == 'guest'" :to="{name: 'activate-account-manual'}" tag="li"
                           active-class="active"><a><i
                class="icon mdi mdi-pin-help"></i>Активация аккаунта</a>
              </router-link>
              <br>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      is_superuser () {
        let sup = this.$auth.user().is_superuser
        return sup
      },
      ...mapGetters(
        [
          'singleOperator',
          'currentOperator'
        ]
      )
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/LeftSidebar.vue